import { render, staticRenderFns } from "./DocPageFooterPref.vue?vue&type=template&id=05c11b36&scoped=true&"
import script from "./DocPageFooterPref.vue?vue&type=script&lang=js&"
export * from "./DocPageFooterPref.vue?vue&type=script&lang=js&"
import style0 from "./DocPageFooterPref.vue?vue&type=style&index=0&id=05c11b36&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05c11b36",
  null
  
)

export default component.exports